export const FETCH_CURRENT_REQUEST = 'partners/FETCH_CURRENT_REQUEST'
export const FETCH_CURRENT_SUCCESS = 'partners/FETCH_CURRENT_SUCCESS'
export const FETCH_CURRENT_FAILURE = 'partners/FETCH_CURRENT_FAILURE'
// user_settings текущего пользователя из service_partners#me (business_apps#1486)
export const SET_USER_SETTINGS = 'partners/SET_USER_SETTINGS'

export const CREATE_PARTNER_REQUEST = 'partners/CREATE_PARTNER_REQUEST'
export const CREATE_PARTNER_SUCCESS = 'partners/CREATE_PARTNER_SUCCESS'
export const CREATE_PARTNER_FAILURE = 'partners/CREATE_PARTNER_FAILURE'

export const VERIFY_PHONE_NUMBER_REQUEST =
  'partners/VERIFY_PHONE_NUMBER_REQUEST'
export const VERIFY_PHONE_NUMBER_SUCCESS =
  'partners/VERIFY_PHONE_NUMBER_SUCCESS'
export const VERIFY_PHONE_NUMBER_FAILURE =
  'partners/VERIFY_PHONE_NUMBER_FAILURE'

export const CONFIRM_PHONE_NUMBER_REQUEST =
  'partners/CONFIRM_PHONE_NUMBER_REQUEST'
export const CONFIRM_PHONE_NUMBER_SUCCESS =
  'partners/CONFIRM_PHONE_NUMBER_SUCCESS'
export const CONFIRM_PHONE_NUMBER_FAILURE =
  'partners/CONFIRM_PHONE_NUMBER_FAILURE'
